module.exports = __webpack_public_path__ + "media/src/images/abouts/devices/02-eff9c444c1242a82f83e1a27694909a5.png";